<template>
    <div>
        <v-container justify-start>
            <v-layout
                v-bind="{
                    column: $vuetify.breakpoint.xsOnly,
                    row: $vuetify.breakpoint.smAndUp
                }"
                wrap
                align-content-start
                justify-start
            >
                <v-flex shrink>
                    <div class="title mb-2 mr-2">New Matchup</div>
                </v-flex>
                <v-divider vertical class="hidden-xs-only mr-2"></v-divider>
                <v-flex align-self-start>
                    <v-breadcrumbs divider=">" style="display:inline; padding-left: 0;">
                        <v-breadcrumbs-item style to="/admin" v-bind:exact="exact">Administration</v-breadcrumbs-item>
                        <v-breadcrumbs-item style to="/admin/playoffs" v-bind:exact="exact">Playoffs</v-breadcrumbs-item>
                        <v-breadcrumbs-item style to="/admin/playoffs/new_matchup" v-bind:exact="exact">New Matchup</v-breadcrumbs-item>
                    </v-breadcrumbs>
                </v-flex>
            </v-layout>
            <v-divider></v-divider>
        </v-container>
        <v-container grid-list-md>
            <v-layout row wrap justify-start>
                <v-flex xs12 sm6>
                    <v-card>
                        <v-card-text>
                            <v-form ref="form" v-model="valid">
                                <v-text-field label="Season" v-model="season.season" readonly></v-text-field>
                                <v-text-field label="Round" v-model="round.round_title" readonly></v-text-field>
                                <v-select
                                    v-model="awayTeamId"
                                    v-bind:items="teams"
                                    label="Away Team"
                                    v-bind:rules="teamRules"
                                    required
                                ></v-select>
                                <v-select
                                    v-model="homeTeamId"
                                    v-bind:items="teams"
                                    label="Home Team"
                                    v-bind:rules="teamRules"
                                    required
                                ></v-select>
                            </v-form>
                        </v-card-text>
                        <v-divider></v-divider>
                        <v-card-actions>
                            <v-btn
                                flat
                                color="primary"
                                v-bind:disabled="!valid"
                                v-on:keyup.enter="submit"
                                v-on:click="submit"
                                data-cy="signinSubmitBtn"
                            >Create Matchup</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
export default {
    name: 'AdminPlayoffsMatchupNew',
    props: ['round'],
    data() {
        return {
            exact: true,
            valid: false,
            season: '',
            awayTeamId: '',
            homeTeamId: '',
            teamRules: [
                // Verify teams are not already playing at this time.
                () => {
                    if (this.awayTeamId === this.homeTeamId && this.awayTeamId && this.homeTeamId) {
                        return 'Away and home teams must be different.'
                    } else {
                        return true
                    }
                }
            ]
        }
    },
    mounted() {
        this.season = this.$store.getters.getSeasonById(this.round.season_id)
    },
    methods: {
        submit() {
            if (this.$refs.form.validate()) {
                this.$store.dispatch('createPlayoffMatchup', {
                    season: this.season,
                    round: this.round,
                    away_team_id: this.awayTeamId,
                    home_team_id: this.homeTeamId
                })
            }
        }
    },
    computed: {
        teams() {
            let teams = this.$store.getters.getTeamsSortedByName
            let teamsDropdown = []

            teams.forEach((team) => {
                teamsDropdown.push({ text: team.team, value: team.id })
            })

            return teamsDropdown
        }
    }
}
</script>

<style scoped>
</style>
